import { render, staticRenderFns } from "./market.vue?vue&type=template&id=4d03c82d&scoped=true"
import script from "./market.vue?vue&type=script&lang=js"
export * from "./market.vue?vue&type=script&lang=js"
import style0 from "./market.vue?vue&type=style&index=0&id=4d03c82d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d03c82d",
  null
  
)

export default component.exports